<!--  -->
<template>
  <div class="cen">
    <div class="bai">
      <span class="title">义务教育招生报名系统</span>
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <div class="el-box">
          <el-form-item prop="phone">
            <el-input
              class="input"
              placeholder="请输入手机号"
              maxlength="11"
              v-model="ruleForm.phone"
              auto-complete="off"
              prefix-icon="el-icon-user"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              class="input"
              placeholder="请输入密码"
              :type="passw"
              maxlength="20"
              v-model="ruleForm.password"
              auto-complete="off"
              prefix-icon="el-icon-unlock"
              style="font-size: 1rem"
            >
              <i slot="suffix" :class="icon" @click="showPass"></i>
            </el-input>
          </el-form-item>
          <div class="code_box">
            <el-form-item prop="code" class="yzmdiv">
              <el-input
                placeholder="验证码"
                v-model="ruleForm.code"
                auto-complete="off"
                class="code"
                @keyup.enter.native="submitForm('ruleForm')"
              ></el-input>
              <identify :identifyCode="identifyCode" style="display: inline">
              </identify>
              <span @click="refreshCode()">换一张</span>
            </el-form-item>
          </div>

          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
            class="button"
            :loading="codeDisabled"
            >登录</el-button
          >

          <div class="last">
            <p @click="back">用户须知</p>
            <!-- <p>
              <span
                @click="gotoCheck"
                style="margin-left: 0.8rem; text-decoration: underline"
                >使用须知</span
              >
            </p> -->
            <div class="last_right">
              <span @click="goto">注册</span>&nbsp;|&nbsp;<span @click="forget"
                >忘记密码</span
              >
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import "element-ui/lib/theme-chalk/index.css";
import sessionUtils from "@/utils/session-store-utils";
import { login } from "@/api/news";
import identify from "@/components/identify.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    identify,
  },
  data() {
    //这里存放数据
    return {
      year: "",
      login: [],
      codeDisabled: false,
      disabled: false,
      // 用于显示或隐藏添加修改表单
      add: false,
      // 用于改变Input类型
      passw: "password",
      // 用于更换Input中的图标
      icon: "el-input__icon el-icon-view",
      ruleForm: {
        phone: "",
        password: "",
        code: "",
      },
      rules: {
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        // code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      identifyCode: "",
      identifyCodes: "23456789abcdefghjkmnpqrstuvwxyz",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  mounted() {
    // 禁用浏览器返回键
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", this.disableBrowserBack);
  },
  destroyed() {
    // 清除popstate事件 否则会影响到其他页面
    window.removeEventListener("popstate", this.disableBrowserBack, false);
  },
  created() {
    // 初始化验证码
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
    this.year = new Date().getFullYear();
    // if (!this.$cookie.get("login")) {
    //   this.$router.push("notice-check");
    //   this.$cookie.set("login", "true");
    // }
  },
  methods: {
    submitForm(formName) {
      this.codeDisabled = true;
      if (this.ruleForm.code.toLowerCase() !== this.identifyCode) {
        this.$toast("输入验证码错误，请重试!");
        this.codeDisabled = false;
      } else if (this.ruleForm.phone === "" || this.ruleForm.password === "") {
        this.$toast("账号或密码不能为空");
        this.codeDisabled = false;
      } else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.formsub();
            // this.getCheckYear();
          } else {
            console.log("error submit!!");
            this.codeDisabled = false;
          }
        });
      }
      this.refreshCode();
    },
    gotoCheck() {
      this.$router.push("/");
    },
    //登录
    async formsub() {
      const params = Object.assign({}, this.ruleForm);
      const res = await login(params);
      console.log(res);
      this.identifyCode = "";
      this.ruleForm.code = "";
      this.makeCode(this.identifyCodes, 4);
      if (res.code == "200") {
        this.$toast("登录成功");
        this.codeDisabled = false;
        sessionStorage.setItem("token", JSON.stringify(res.data.token));
        sessionUtils.login();
        sessionUtils.setUser(res.data.login);
        await this.$router.push("create");
      } else {
        this.$toast(res.msg);

        this.codeDisabled = false;
        return false;
      }
    },
    // 获取审证年度
    async getCheckYear() {
      const params = Object.assign({});
      const res = await getCheckYear(params);
      sessionUtils.setCheckYear(res.data.value);
    },
    /** 图形验证码 */
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },

    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },

    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode +=
          this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
    },
    showPass() {
      // 点击图标是密码隐藏或显示
      if (this.passw == "text") {
        this.passw = "password";
        // 更换图标
        this.icon = "el-input__icon el-icon-view";
      } else {
        this.passw = "text";
        this.icon = "el-input__icon  el-icon-minus";
      }
    },
    back() {
      this.$router.push("/");
    },
    goto() {
      this.$router.push("reg");
    },
    forget() {
      this.$router.push("forget");
    },
    disableBrowserBack() {
      history.pushState(null, null, document.URL);
    },
  },

  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前

  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
/*@import url(); 引入公共css类*/
.cen {
  min-height: calc(100vh - 2rem);
  background: url("../assets/images/bg2.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.bai {
  background-color: #fff;
  width: 90%;
  border-radius: 0.36rem;
  padding-top: 1rem;
  margin-top: 4rem;
}
.demo-ruleForm {
  width: 13rem;
  height: 11rem;
  margin: 0.2rem auto;
  background: #fff;
  // padding: 0.2rem;
  border-radius: 0.4rem;
  box-sizing: border-box;
}
.demo-ruleForm .el-form-item__content {
  margin-left: 0rem !important;
  margin-bottom: 0.88rem;
}
.demo-ruleForm .el-input__inner {
  height: 2.4rem;
  line-height: 2.4rem;
  font-size: 0.72rem;
  text-indent: 0.8rem;
}
.demo-ruleForm .span {
  font-family: PingFangSC-Regular;
  font-size: 0.72rem;
  color: #1d1d1d;
  letter-spacing: 0.0436rem;
  line-height: 1.76rem;
  border-bottom: 0.36rem solid #febf1e;
}
.demo-ruleForm .el-box {
  margin-top: 2rem;
}
.demo-ruleForm .el-box .input {
  border-radius: 0.36rem;
}
.demo-ruleForm .el-box .code {
  width: 4.5rem;
}

.code_box {
  margin-bottom: 1rem;
}
.code_box span {
  margin-left: 0.4rem;
  font-size: 0.64rem;
  color: #0f9386;
  cursor: pointer;
}
.demo-ruleForm .el-box .button {
  display: block;
  width: 13rem;
  height: 1.6rem;
  margin-top: -0.56rem;
  background: #0f9386;
  border-radius: 0.08rem;
  font-family: PingFangSC-Regular;
  font-size: 0.72rem;
  color: #ffffff;
  letter-spacing: 0.8rem;
  outline: none;
  border: none;
}
.demo-ruleForm .el-box .last {
  margin-top: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.demo-ruleForm .el-box .last p {
  display: inline-block;
  font-family: PingFangSC-Regular;
  font-size: 0.64rem;
  color: #0f9386;
  letter-spacing: 0.001rem;
}
.demo-ruleForm .el-box .last .last_right {
  display: inline-block;
  float: right;
  font-size: 1rem;
  color: #ccc;
}
.demo-ruleForm .el-box .last .last_right span {
  font-family: PingFangSC-Regular;
  font-size: 0.64rem;
  color: #0f9386;
  letter-spacing: 0.0352rem;
  cursor: pointer;
}
.yzmdiv {
  display: flex;
  align-items: center;
}
/deep/.el-form-item__content {
  display: flex;
}
/deep/.el-input__icon {
  width: 1rem;
  font-size: 0.72rem;
}
/deep/.el-input--suffix .el-input__inner {
  font-size: 0.64rem;
}
</style>
